/**
 * 交易数据滚动信息
 */
import React from 'react';
import { Row, Col, Typography, Table } from 'antd';
import http from '../../../axios/http';
const columns = [
    {
        title: '车牌号',
        dataIndex: 'plateNo',
    }, {
        title: '车价',
        dataIndex: 'amount',
    }, {
        title: '新车主',
        dataIndex: 'buyerName',
    }, {
        title: '申请时间',
        dataIndex: 'insertTime'
    },
];

class DealChart extends React.Component {
    state = {
        finished: [],
        processing: [],
        finishedStart: 0,
        processingStart: 0,
        showNum: 10,    //显示条数
    }

    componentDidMount() {
        this.timer();
        this.interval = setInterval(() => this.timer(), 3000);
 
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    timer = () => {
        let finishedStart = (this.state.finishedStart) * (this.state.showNum);
        let processingStart = (this.state.processingStart) * (this.state.showNum);
        let finishedLength = this.state.finished.length - this.state.showNum;
        let processingLength = this.state.processing.length - this.state.showNum;

        if (finishedStart >= finishedLength && processingStart > processingLength) {
            //如果两个开始都大于结束的最大长度，说明已经滚动完了。需要重新加载
            this.loadAppData();
        } else {
            //不需要重新加载，只需要将两个列表滚动播放
            finishedStart = finishedStart >= finishedLength ? 0 : this.state.finishedStart + 1;
            processingStart = processingStart >= processingLength ? 0 : this.state.processingStart + 1;
        }
        this.setState({
            finishedStart: finishedStart,
            processingStart: processingStart
        });
    }

    loadAppData = () => {
        http.post({
            url: '/application/findTodayApplication',
            success: (res) => {
                let finished = [];
                let processing = [];
                if (res != null && res.length > 0) {
                    for (let i = 0; i < res.length; i++) {
                        if(res[i].buyerCreditType !== 'C1' && res[i].buyerCreditType !== 'C2' && res[i].buyerCreditType !== 'C3'){
                            let buyerName = res[i].buyerName;
                            if(buyerName != null && buyerName.length > 1){
                                res[i].buyerName = buyerName.substr(0, 1)+"*"+buyerName.substr(2, buyerName.length);
                            }
                        }
                        if (res[i].invoiceState === 1) {
                            //已完成
                            finished.push(res[i]);
                        } else {
                            //未完成
                            processing.push(res[i]);
                        }
                    }
                }
                this.setState({
                    processing: processing,
                    finished: finished,
                    finishedStart: 0,
                    processingStart: 0
                });
            }
        });
    }


    render() {
        let start = (this.state.finishedStart) * (this.state.showNum);
        let end = start + this.state.showNum;
        end = end > this.state.finished.length ? this.state.finished.length : end;
        let finished = this.state.finished.slice(start, end);

        start = (this.state.processingStart) * (this.state.showNum);
        end = start + this.state.showNum;
        end = end > this.state.processing.length ? this.state.processing.length : end;
        let processing = this.state.processing.slice(start, end);

        return (
            <div style={{ width: "100%", height: "100%" }} className='tableBg'>
                <Row>
                    <Col span={12} style={{ padding: '10px' }}>
                        <Typography.Title >今日已完成交易信息</Typography.Title >
                        <Table columns={columns} dataSource={finished} bordered={true} pagination={false} rowKey="applicationId" />
                    </Col>
                    <Col span={12} style={{ padding: '10px' }}>
                        <Typography.Title >今日交易中信息</Typography.Title >
                        <Table columns={columns} dataSource={processing} bordered={true} pagination={false} rowKey="applicationId" />
                    </Col>
                </Row>
            </div>
        )
    }
}

export default DealChart;